import english from '@/i18n/english'
import spanish from '@/i18n/spanish'

export type TranslationObject = typeof english | typeof spanish
export type TranslationKey = keyof TranslationObject
export type TranslationValue<K extends TranslationKey> = TranslationObject[K]

export const getTranslation = (language: string): TranslationObject => {
  if (language.toLowerCase() === 'english') {
    return english
  } else if (language.toLowerCase() === 'spanish') {
    return spanish
  } else {
    throw new Error(`language ${language} not found`)
  }
}
